import {create} from "zustand";

const useDeviceStore = create((set) => ({
    isDeviceUpdated: false,

    setDeviceUpdated: (device) => set({isDeviceUpdated: device}),
}));

export default useDeviceStore